<template>
  <div>
    <article v-if="userIsAParent">
      <nav-title :color="false" :title="'Progress'" />
      <section>
        <b-nav pills class="w-100 border border-main main-nav">
          <b-nav-item
            :active="!showChild"
            class="w-50 text-uppercase text-center rounded-0"
            @click="showChild = false"
          >
            Me
          </b-nav-item>
          <b-nav-item
            :active="showChild"
            class="w-50 text-uppercase text-center"
            @click="showChild = true"
          >
            My child
          </b-nav-item>
        </b-nav>
        <child-progress v-if="showChild" />
        <parent-progress v-else />
      </section>
    </article>
    <article v-else>
      <child-progress />
    </article>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import navTitle from '@/components/general/navTitle.vue';
import parentProgress from '@/components/progress/parentProgress.vue';
import childProgress from '@/components/progress/childProgress.vue';
import store from '@/store';

export default {
  components: {
    navTitle,
    parentProgress,
    childProgress,
  },
  data() {
    return {
      showChild: true,
    };
  },
  computed: {
    ...mapGetters('user', ['userIsAParent', 'getUserName']),
  },
  beforeRouteEnter(to, from, next) {
    const userId = store.getters['user/getUserId'];
    let promiseEvents = [];
    if (store.getters['user/userIsAParent']) {
      promiseEvents = [
        store.dispatch('progress/fetchPopups'),
        store.dispatch('progress/FetchParentPointsBySkill', userId),
        store.dispatch('progress/FetchParentPointsPerTime', { parentId: userId }),
        store.dispatch('progress/FetchChildrenStarProgress', { parentId: userId }),
        store.dispatch('progress/FetchChildrenGoalsProgress', { parentId: userId }),
        store.dispatch('user/getUserData', {
          userIsAparent: store.getters['user/userIsAParent'],
          userId: userId,
        }),
      ];
    } else {
      promiseEvents = [store.dispatch('progress/FetchChildStars', { childId: userId })];
    }
    Promise.all(promiseEvents).then(() => {
      next();
    });
  },
};
</script>
<style lang="scss">
.main-nav .nav-link {
  border-radius: 0 !important;
}
</style>
